//loginStatusSocket.js
import router from '@/router'
import store from '@/store'
import { ElMessageBox } from 'element-plus'

let ws = null
let isKicked = false

//token
function getToken() {
    const s = store.state
    return (
        store.getters.frontToken ||
        s.frontToken || s.token || s.frontUserToken ||
        localStorage.getItem('token') ||
        sessionStorage.getItem('token') ||
        ''
    )
}

export function connectLoginStatusSocket(token) {
    const httpurl =
        process.env.VUE_APP_TITLE == "样衣星球测试版"
            ? "yyyhao.58guoyin.com"
            : "www.yyyhao.com";
    const tk = token || getToken()
    if (!tk || tk === 'null' || tk === 'undefined') {
        console.warn('[ws] 无有效 token，跳过在线状态监听')
        return
    }
    closeLoginStatusSocket()   //统一关闭
    isKicked = false
    ws = new WebSocket(
        `wss://${httpurl}/wss/yyyhao-cloud-auth/online/${encodeURIComponent(tk)}`
    )
    ws.onopen = () => console.log('[ws] 在线状态监听已连接')
    ws.onmessage = (e) => {
        const d = e.data
        if (typeof d === 'string' && d.startsWith('511')) handleKickedOut(d)
    }
    ws.onclose = (e) => console.log('[ws] 连接关闭', e.code, e.reason)
    ws.onerror = (err) => console.error('[ws] error', err)
}

async function handleKickedOut() {
    if (isKicked) return
    isKicked = true
    //1.立刻断开
    closeLoginStatusSocket()

    //2.清空登录态
    localStorage.removeItem('token')
    store.dispatch('frontLogout')
    const message = '当前账号已在其他设备登录,请重新登录'

    //4.弹框，等用户点击确定
    try {
        await ElMessageBox.confirm(message, '提示', {
            confirmButtonText: '确定',
            showCancelButton: false,
            showClose: false,
            closeOnClickModal: false,
            closeOnPressEscape: false,
            type: 'warning'
        })
    } catch (e) {
        console.log(e, '看你报什么');

    }

    // 5. 用户点击确定才跳转
    router.replace({ name: 'About' }).catch(() => { })


}

export function closeLoginStatusSocket() {
    if (!ws) return
    ws.onopen = ws.onmessage = ws.onclose = ws.onerror = null
    ws.close()
    ws = null
}
